export const getAdPageLink = (adId, adName) => {
  const dashedString = adName.replace(/[^a-zA-Z0-9_]/g, '-');
  const formattedName = dashedString
    .replace(/^-+|-+$/g, '')
    .replace(/-+/g, '-')
    .toLowerCase();
  return `/autos/${adId}-${formattedName}`;
};
